import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import App from "./App.tsx";
import { ThemeProvider } from "./state/theme.tsx";
import { PipelineProvider } from "./state/engine.tsx";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root container '#root' not found in index.html");

createRoot(container).render(
  <StrictMode>
    {/* Hash routing so deep links survive a hard refresh on any static host,
        matching the ontology-explorer app's /tools/<app>/ deployment model. */}
    <HashRouter>
      <ThemeProvider>
        <PipelineProvider>
          <App />
        </PipelineProvider>
      </ThemeProvider>
    </HashRouter>
  </StrictMode>,
);
